import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import Squircle from 'design-system/Squircle';
import { IconUserPlus } from 'design-system/icons';
import IconPlus from 'design-system/icons/IconPlus';
import { Button, CardView, Spacer } from 'design-system';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectExtraMembersInfo } from 'reducers/selectors/sharedPlans';
import { selectFamilyPlanPrices } from '../selectors/stripe';
import useRequiredTierCallback from '../hooks/useRequiredTierCallback';
import { useStoreExtraMembersSuggestion } from '../hooks/useTryAdvertiseExtraMembers';
import { Tier } from '../entities';
const ExtraMembersIntroCard = ({ suggestGroupId, suggestSpaceId, suggestNumOfSlots, }) => {
    const colors = useColors();
    const navigation = useMainStackNavigation();
    const familyPlanPrices = useAppSelector(selectFamilyPlanPrices);
    const extraMembersInfo = useAppSelector(selectExtraMembersInfo);
    const storeSuggestion = useStoreExtraMembersSuggestion();
    const handleInvite = useRequiredTierCallback(React.useCallback(() => {
        storeSuggestion({ suggestGroupId, suggestSpaceId });
        if (extraMembersInfo?.totalSeats) {
            if (extraMembersInfo.canAddSlot) {
                navigation.navigate('SelectNumberOfSlots', {
                    initialNumber: suggestNumOfSlots,
                });
            }
            else {
                navigation.navigate('ManageExtraMembers');
            }
        }
        else {
            // has no slot
            navigation.navigate('ExtraMembersIntro', {
                numberOfSlotsNeeded: suggestNumOfSlots,
            });
        }
    }, [
        extraMembersInfo,
        suggestGroupId,
        suggestSpaceId,
        suggestNumOfSlots,
        storeSuggestion,
    ]), Tier.ultimate);
    if (!familyPlanPrices)
        return null;
    return (<CardView noMarginTop noMarginBottom withPadding>
      <Squircle color={colors.background.dark}>
        <IconUserPlus colorKey="brand"/>
      </Squircle>
      <Spacer h={16}/>
      <Text Text-16>Bring others into your plan</Text>
      <Spacer h={4}/>
      <Text TextThin-14 Secondary>
        Invite up to 4 people to join your Emma Ultimate plan for just{' '}
        {familyPlanPrices.localizedPrice}/{familyPlanPrices.period} each. It’s
        an easy, affordable way to support those you care about
      </Text>
      <Spacer h={16}/>
      <View style={styles.row}>
        <Button hug square brand onPress={handleInvite} title="Invite members" leftIcon={<IconPlus width={11} height={11} color={colors.text.whiteOnColor}/>}/>
      </View>
    </CardView>);
};
export default ExtraMembersIntroCard;
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
    },
});
